<template>
<v-card v-show="display">
    <v-card-title>
        Baseline Survey Submission<span v-if="$attrs.debug">DYSPORT-2024 Last Submission Widget</span>
    </v-card-title>
    <v-card-text>
        <template v-if="submissions">
            Submitted on: {{ formatDate(submissions[0].submitted) }}        
            <v-list v-if="submissions && $attrs.debug">
                <v-list-item v-for="submission in submissions" :key="`record-${submission.id}`">
                    <v-list-item-content>
                       Submission ID [{{ submission.id }}] - {{ submission.submitted }}
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>
        <template v-else>
            No submissions
        </template>
        
    </v-card-text>
</v-card>
</template>

<script>

export default {
    name: 'datePuller',
    props: {
        questionMap: {
            type: Object,
            required: true
        }
    },
    mounted(){
        this.getSubmissions()
    },
    data(){
        return {
            config: {
                questionId: 1,
                groupId: 1,
                inputId: 1,
                role: this.$route.params.role ? this.$route.params.role : 'user',
            },
            submissions: null
        }
    },
    methods: {
        setValue(value){
            let questionMap = this.questionMap
            let config = this.config
            questionMap[config.questionId].value[config.groupId][config.inputId] = value
        },
        formatDate(t){
            var year = t.toLocaleString("default", { year: "numeric" });
            var month = t.toLocaleString("default", { month: "2-digit" });
            var day = t.toLocaleString("default", { day: "2-digit" });
            return `${year}-${month}-${day}`
        },
        async getSubmissions(){
            this.submissions = null
            var action = 'survey';
            var call = 'getSubmissions';
            var data = {
                survey_id: process.env.NODE_ENV == 'development' ? 101 : 93,
                program_id: 30,
                role: this.config.role,
            }
            let response = await this.$sendRequest({
                action: action,
                call: call,
                data: data
            })

            if(response.status==200){
                this.submissions = response.data[action][call].results
                let submissions = this.submissions
                let records = submissions
                for(let i=0; i<records.length; i++){
                    let record = records[i]
                    record.submitted = new Date(record.timestamp.replace(/ /g,"T"))
                }
                submissions.sort((a,b)=>{return a.submitted>b.submitted})
                let lastSubmission = this.formatDate(submissions[0].submitted)
                this.setValue(lastSubmission)
            }
        }
    },
    computed: {
        lastSubmission(){
            let submissions = this.submissions
            if(submissions){
                let records = submissions
                for(let i=0; i<records.length; i++){
                    let record = records[i]
                    record.submitted = new Date(record.timestamp.replace(/ /g,"T"))
                }
                return submissions.sort((a,b)=>{return a.submitted>b.submitted})[0]
            }
            return null
        },
        display(){
            return true
            //return ['test','edit'].includes(this.$store.getters.mode)
        }
    }
}
</script>

<style module>

</style>

